<p-progressBar mode="indeterminate" class="m-2" *ngIf="isLoading"></p-progressBar>
<p *ngIf="downloadError" role="alert">{{ downloadError }}</p>
<div class="card pt-2 pb-2">
</div>
<p-table [value]="invoices" dataKey="invoiceId" [resizableColumns]="true" styleClass="p-datatable-gridlines" [tableStyle]="{ 'min-width': '60rem' }"
         [paginator]="true" [rows]="20" [first]="first" [showCurrentPageReport]="true" [totalRecords]="totalRequests" [lazy]="true"
         currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" (onLazyLoad)="loadData($event)"
         [rowsPerPageOptions]="[20, 50, 100]">
    <ng-template pTemplate="caption">
        <div class="col-12 flex overflow-hidden">
            <div class="flex-none flex align-items-center justify-content-center">
                <h2>Invoices</h2>
            </div>
            <div class="flex-grow-1 flex align-items-center justify-content-center"></div>
            <div class="flex-none flex align-items-center justify-content-center">
                <p-button label="Export to Excel" icon="pi pi-file-excel" (click)="exportToExcel()" class="p-2" severity="help"></p-button>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th style="width: 5rem"></th>
            <th>Type</th>
            <th>From</th>
            <th>Invoice#</th>
            <th>Invoice Date</th>
            <th>Amount Excluding VAT</th>
            <th>Tax Amount</th>
            <th>Total Amount</th>
            <th>Status</th>
            <th>Paid With</th>
            <th>Actions</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-invoice let-expanded="expanded">
        <tr>
            <td>
                <button type="button" pButton pRipple [pRowToggler]="invoice"
                        class="p-button-text p-button-rounded p-button-plain"
                        [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
            </td>
            <td>{{ invoice.invoiceType }}</td>
            <td>{{ invoice.owningCompany != undefined ? invoice.owningCompany.name : 'LogiLink' }}</td>
            <td>{{ invoice.invoiceNumber }}</td>
            <td>{{ showDate(invoice.invoiceCreationDate) }}</td>
            <td>{{ invoice.country.currencyCode + ' ' + invoice.totalAmountExclTax }}</td>
            <td>{{ invoice.country.currencyCode + ' ' + invoice.totalTax }}</td>
            <td>{{ invoice.country.currencyCode + ' ' + invoice.totalAmount }}</td>
            <td>
                <p-tag *ngIf="showInvoiceStatus(invoice)" icon="fa-solid fa-check" severity="success" value="PAID"></p-tag>
                <p-tag *ngIf="!showInvoiceStatus(invoice)" icon="fa-solid fa-close" severity="danger" value="UNPAID"></p-tag>
            </td>
            <td>{{ showAllReceiptNumberWithComma(invoice.receipts) }}</td>
            <td>
        <span class="p-buttonset">
            <app-finance-pdf-view-button kind="invoice" [documentId]="invoice.invoiceId" [documentReference]="invoice.invoiceNumber" [postingStatus]="invoice.postingStatus" [iconOnly]="true" [disabled]="documentActions.isPending(invoice.invoiceId)" *ngIf="canDownloadInvoice"></app-finance-pdf-view-button>
            <p-button [pTooltip]="invoice.postingStatus === 'POSTED' ? 'Download Invoice' : 'Print / reprint draft from latest saved changes'"
                [icon]="invoice.postingStatus === 'POSTED' ? 'pi pi-download' : 'pi pi-print'" [loading]="documentActions.isPending(invoice.invoiceId)" (click)="downloadInvoice(invoice)" class="p-1" severity="info"></p-button>
        </span>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="expandedrow" let-invoice>
        <tr>
            <td colspan="12" class="p-3">
                <p-table [value]="invoice.invoiceLines" dataKey="invoiceLineId" [resizableColumns]="true" styleClass="p-datatable-gridlines border-1 surface-border" [tableStyle]="{ 'min-width': '60rem' }">
                        <ng-template pTemplate="caption">
                            <div class="grid">
                                <div class="col-10">
                                    <h2>Invoice Lines</h2>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th>S#</th>
                                <th>Order#</th>
                                <th>Delivery#</th>
                                <th>Service Type</th>
                                <th>Arabic Description</th>
                                <th>Invoice Comment</th>
                                <th>Charge Amount</th>
                                <th>Actions</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-invoiceLine>
                            <tr>
                                <td>{{ invoiceLine.invoiceLineId }}</td>
                                <td>{{ invoiceLine.headerReferenceNumber }}</td>
                                <td>{{ invoiceLine.detailReferenceNumber }}</td>
                                <td>{{ invoiceLine.itemNumber }}</td>
                                <td dir="rtl">{{ invoiceLine.itemDescriptionLocal || '—' }}</td>
                                <td>{{ invoiceLine.invoiceComment || '—' }}</td>
                                <td>{{ invoice.country.currencyCode + ' ' + invoiceLine.chargeAmount }}</td>
                                <td>
                  <span class="p-buttonset">
                      <p-button pTooltip="Show Order Details" icon="pi pi-eye" (click)="showOrderDetails(invoiceLine)" class="p-1" severity="help"></p-button>
                  </span>
                                </td>
                            </tr>
                        </ng-template>
                </p-table>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="summary">
        <div class="flex align-items-center justify-content-between">
            In total there are {{totalRequests}} Invoices.
        </div>
    </ng-template>
</p-table>
